export default __webpack_public_path__ + "static/media/theme2.c927b86b.png";